import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CheckboxInput from '../../components/CheckboxInput';
import TextInput from '../../components/TextInput';
import Button from '../../components/Button';
import SkeletonLoader from '../../components/SkeletonLoader';
import blogCategoryApi from '../../api/blogCategoryApi';
import { useToast } from '../../contexts/ToastContext';
import { ROUTES } from '../../constants';

const AddBlogCategory = () => {
  const navigate = useNavigate();
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [formData, setFormData] = useState({
    name: '',
    is_active: 1,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? (checked ? 1 : 0) : value,
    });
    if (validationErrors[name]) {
      setValidationErrors(prev => ({ ...prev, [name]: undefined }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setValidationErrors({});

    try {
      await blogCategoryApi.createBlogCategory(formData);
      addToast('Blog category created successfully!', 'success');
      navigate(ROUTES.BLOG_CATEGORIES);
    } catch (err) {
      console.error('Failed to add blog category:', err);
      if (err.response && err.response.status === 422) {
        setValidationErrors(err.response.data.errors || {});
        addToast(err.response.data.message || 'Validation failed. Please check your input.', 'error');
      } else {
        addToast(err.response?.data?.message || 'Failed to add blog category. Please try again.', 'error');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-gray-800 rounded-lg shadow-md text-text-white">
      <h1 className="text-3xl font-bold mb-6">Add New Blog Category</h1>
      {loading ? (
        <SkeletonLoader type="form" />
      ) : (
        <form onSubmit={handleSubmit}>
          <TextInput
            label="Category Name"
            name="name"
            id="name"
            value={formData.name}
            onChange={handleChange}
            required={true}
            placeholder="Category Name"
            error={validationErrors?.name?.[0]}
          />
          <CheckboxInput
            label="Active"
            name="is_active"
            id="is_active"
            checked={formData.is_active}
            onChange={handleChange}
          />
          <div className="flex items-center justify-between mt-6">
            <Button
              type="submit"
              className="bg-accent-red hover:bg-red-700 text-white"
              loading={loading}
            >
              Add Category
            </Button>
            <Button
              type="button"
              onClick={() => navigate(ROUTES.BLOG_CATEGORIES)}
              className="bg-gray-500 hover:bg-gray-600 text-white"
              disabled={loading}
            >
              Cancel
            </Button>
          </div>
        </form>
      )}
    </div>
  );
};

export default AddBlogCategory;